<template>
  <div class="bk-blokkli-item-options-text">
    <input v-model="text" :type="type" :placeholder="label" />
    <div>{{ text }}</div>
  </div>
</template>

<script setup>
import { computed } from "#imports";
const props = defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, required: false, default: "" },
  type: { type: String, required: false, default: "text" }
});
const emit = defineEmits(["update:modelValue"]);
const text = computed({
  get() {
    return props.modelValue || "";
  },
  set(v) {
    emit("update:modelValue", (v === void 0 ? "" : v).toString());
  }
});
</script>

<script>
export default {
  name: "OptionsFormText"
};
</script>
